// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ICompetitionPromotionTypeInfo {
  /** Тип продвижения для конкуренции **/
  promotionType: EPromotionType;
  /** Количество объявлений данного типа продвижения **/
  amount: number;
  /** Уровень конкуренции **/
  competitionLevel: ECompetitionLevel;
}
export enum EPromotionType {
  'NoPromotion' = 'noPromotion',
  'Standard' = 'standard',
  'Premium' = 'premium',
  'Top' = 'top',
  'TopWithBet' = 'topWithBet',
}
export enum ECompetitionLevel {
  'Low' = 'low',
  'Middle' = 'middle',
  'High' = 'high',
}
